import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { Announcement } from '../../../hooks/api/useAnnouncements';

/** Edit, or view when retired (retired announcements are read-only). */
export const AnnouncementOpenButton = ({
  announcement,
  onOpen,
}: {
  announcement: Announcement;
  onOpen: (announcement: Announcement) => void;
}) => {
  const { t } = useTranslation();
  const isRetired = announcement.status === 'retired';
  const label = t(isRetired ? 'announcements.view' : 'announcements.edit', {
    title: announcement.title,
  });
  const Icon = isRetired ? VisibilityIcon : EditIcon;

  return (
    <Tooltip title={label}>
      <Button
        variant="link"
        aria-label={label}
        onClick={() => onOpen(announcement)}
        size="small"
        sx={{
          minWidth: 'unset',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
        }}
      >
        <Icon aria-hidden="true" />
      </Button>
    </Tooltip>
  );
};
